module.exports = __webpack_public_path__ + "static/media/Circle-outline.5e7d34b4.png";